import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

import { Text } from '@components/ui-core/text/text'
import { type PolymorphicElementProps, type TextTag } from '@components/ui-core/types'

import styles from './homepage-text.module.css'

type HomepageTextVariant =
  | 'headingMedium'
  | 'headingLarge'
  | 'copy'
  | 'heroCard'
  | 'heroTitle'
  | 'heroHeading'

export type HomepageTextProps = ComponentPropsWithoutRef<TextTag> &
  PolymorphicElementProps<TextTag> & {
    variant: HomepageTextVariant
  }

const variantToClassNameMap: Record<NonNullable<HomepageTextProps['variant']>, string> = {
  headingMedium: styles.headingMedium,
  headingLarge: styles.headingLarge,
  copy: styles.copy,
  heroCard: styles.heroCard,
  heroTitle: styles.heroTitle,
  heroHeading: styles.heroHeading,
}

export function HomepageText(props: HomepageTextProps): ReactElement {
  const { as = 'p', children, className, variant, ...rest } = props
  return (
    <Text as={as} className={clsx(variant && variantToClassNameMap[variant], className)} {...rest}>
      {children}
    </Text>
  )
}
